/**
 * Navigation AST slice. Populated by the on-open AST sync from the parsed
 * navigation source (navigators / screens / routes). The single read path
 * for navigation-aware panels.
 */
import isEqual from 'lodash/isEqual';

import type { NavigationData } from '@/ast/readers/navigation/navigationSourceCodec';

export interface NavigationAstState {
  data: NavigationData | null;
  source: string | null;
}

const navigationAstInitial: NavigationAstState = { data: null, source: null };

export type NavigationAstAction =
  | { type: 'NAVIGATION_AST_SET'; data: NavigationData; source: string }
  | { type: 'NAVIGATION_AST_CLEAR' };

export function navigationAst(
  state: NavigationAstState = navigationAstInitial,
  action: any,
): NavigationAstState {
  switch ((action as NavigationAstAction).type) {
    case 'NAVIGATION_AST_SET': {
      const a = action as Extract<NavigationAstAction, { type: 'NAVIGATION_AST_SET' }>;
      if (state.source === a.source && isEqual(state.data, a.data)) return state;
      return { data: a.data, source: a.source };
    }
    case 'NAVIGATION_AST_CLEAR':
      return navigationAstInitial;
    default:
      return state;
  }
}

export const setNavigationAst = (data: NavigationData, source: string): NavigationAstAction => ({
  type: 'NAVIGATION_AST_SET',
  data,
  source,
});
